import { useQuery } from '@tanstack/react-query'
import { KeomedesValidatorResponse, KleomedesValidator } from '../app/(juno)/api/validator/route'

export const useKleomedesValidators = () => {
  const { isLoading, error, data } = useQuery<KeomedesValidatorResponse, Error>({
    queryKey: ['kleomedesValidators'],
    queryFn: () =>
      fetch('/api/validator', {
        method: 'GET',
      }).then(res => res.json()),
  })

  return {
    isLoading,
    error,
    data,
  }
}
